module.exports = __webpack_public_path__ + "fonts/VaIcons.59a3fe21.ttf";